export default __webpack_public_path__ + "static/logo-freshcells-systems-engineering-large-41bbcbf08fda6c2a84db9809a9a57581.jpg";